const observer = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === "childList") {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.matches('span')) {
          handleVariantChange(node);
        }
      });
    }

    if (mutation.type === "characterData") {
      const node = mutation.target.parentElement;
      if (node && node.matches('span')) {
        handleVariantChange(node);
      }
    }
  }
});

function handleVariantChange(el) {
  const variantName = el.textContent.trim();
  const normalized = variantName.replace(/\s+/g, "-");
  const expectedId = `${normalized}__images`;

  const targetWrapper = document.getElementById(expectedId);
  if (targetWrapper) {
    // Reset all wrappers
    document.querySelectorAll(".product-color_image-wrapper").forEach((wrapper) => {
      wrapper.classList.remove("is--image--active");
      wrapper.style.display = "none";
    });

    // Activate matched wrapper
    targetWrapper.classList.add("is--image--active");
    targetWrapper.style.display = "flex"; // or "block"
  }
}

const productMainList = document.querySelectorAll(".product-color-area");

productMainList.forEach((area) => {
  observer.observe(area, {
    childList: true,
    subtree: true,
    characterData: true, // also watch text changes
  });
});
